// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud Costs API
 * API to get cloud cost information about Aura components and dev environments. Is used by the Aura Portal.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApitypesCloudProvider } from './ApitypesCloudProvider';
import {
  ApitypesCloudProviderFromJSON,
  ApitypesCloudProviderFromJSONTyped,
  ApitypesCloudProviderToJSON,
  ApitypesCloudProviderToJSONTyped,
} from './ApitypesCloudProvider';

/**
 *
 * @export
 * @interface ApitypesUpsertEnvironmentsCostsRequest
 */
export interface ApitypesUpsertEnvironmentsCostsRequest {
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentsCostsRequest
   */
  cloudHostID?: string;
  /**
   *
   * @type {ApitypesCloudProvider}
   * @memberof ApitypesUpsertEnvironmentsCostsRequest
   */
  cloudProvider?: ApitypesCloudProvider;
  /**
   *
   * @type {number}
   * @memberof ApitypesUpsertEnvironmentsCostsRequest
   */
  cost?: number;
  /**
   * Format: 2026-12-31
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentsCostsRequest
   */
  dateIncurred?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentsCostsRequest
   */
  environmentID?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentsCostsRequest
   */
  environmentName?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentsCostsRequest
   */
  serviceDescription?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentsCostsRequest
   */
  serviceID?: string;
}

/**
 * Check if a given object implements the ApitypesUpsertEnvironmentsCostsRequest interface.
 */
export function instanceOfApitypesUpsertEnvironmentsCostsRequest(
  value: object,
): value is ApitypesUpsertEnvironmentsCostsRequest {
  return true;
}

export function ApitypesUpsertEnvironmentsCostsRequestFromJSON(
  json: any,
): ApitypesUpsertEnvironmentsCostsRequest {
  return ApitypesUpsertEnvironmentsCostsRequestFromJSONTyped(json, false);
}

export function ApitypesUpsertEnvironmentsCostsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApitypesUpsertEnvironmentsCostsRequest {
  if (json == null) {
    return json;
  }
  return {
    cloudHostID: json['cloudHostID'] == null ? undefined : json['cloudHostID'],
    cloudProvider:
      json['cloudProvider'] == null
        ? undefined
        : ApitypesCloudProviderFromJSON(json['cloudProvider']),
    cost: json['cost'] == null ? undefined : json['cost'],
    dateIncurred:
      json['dateIncurred'] == null ? undefined : json['dateIncurred'],
    environmentID:
      json['environmentID'] == null ? undefined : json['environmentID'],
    environmentName:
      json['environmentName'] == null ? undefined : json['environmentName'],
    serviceDescription:
      json['serviceDescription'] == null
        ? undefined
        : json['serviceDescription'],
    serviceID: json['serviceID'] == null ? undefined : json['serviceID'],
  };
}

export function ApitypesUpsertEnvironmentsCostsRequestToJSON(
  json: any,
): ApitypesUpsertEnvironmentsCostsRequest {
  return ApitypesUpsertEnvironmentsCostsRequestToJSONTyped(json, false);
}

export function ApitypesUpsertEnvironmentsCostsRequestToJSONTyped(
  value?: ApitypesUpsertEnvironmentsCostsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloudHostID: value['cloudHostID'],
    cloudProvider: ApitypesCloudProviderToJSON(value['cloudProvider']),
    cost: value['cost'],
    dateIncurred: value['dateIncurred'],
    environmentID: value['environmentID'],
    environmentName: value['environmentName'],
    serviceDescription: value['serviceDescription'],
    serviceID: value['serviceID'],
  };
}
